// ProjectsDashboardMenu.js
import React from 'react';
import { Menu } from '@react-admin/ra-rbac';
import BookIcon from '@mui/icons-material/Book';
import PeopleIcon from '@mui/icons-material/People';
import { Link, Route } from 'react-router-dom';
import VideoComponent from '../components/VideoComponent';
import { IfCanAccess } from '@react-admin/ra-rbac';
import { MenuItem } from '@mui/material';



export const ProjectsDashboardMenu = () => {

  return (
    <Menu>
      
      <IfCanAccess action='list' resource='loginusers'>
        <MenuItem>
            <a className="link" href="https://portal.wmca.org.uk/usermanagement/" rel="noopener noreferrer" >
                <div id="menuDiv" className="MuiListItemIcon-root RaMenuItemLink-icon css-cveggr-MuiListItemIcon-root" >
                    <PeopleIcon />
                    User Management System
                </div>
            </a>
        </MenuItem>
      </IfCanAccess>


      <Link to="/training-videos" className="link">
        <div id="menuDiv" className="MuiListItemIcon-root RaMenuItemLink-icon css-cveggr-MuiListItemIcon-root">
          <BookIcon />
          Training Videos
        </div>
      </Link>

    </Menu>
  );
};






/*


      <MenuItem>
          <a className="link" href="../training-videos" rel="noopener noreferrer" >
              <div id="menuDiv" className="MuiListItemIcon-root RaMenuItemLink-icon css-cveggr-MuiListItemIcon-root" >
                  <BookIcon />
                  Training videos
              </div>
          </a>
      </MenuItem>


*/

